import api from './Api';

export const getStudentPhotoUrl = (student) => {
  const picture = [student?.profilePicture, student?.user?.profilePicture]
    .find(value => typeof value === 'string' && value.trim());
  if (!picture) return undefined;

  const path = picture.trim();
  if (/^(https?:\/\/|blob:|data:image\/)/i.test(path)) return path;
  if (/^[a-z][a-z\d+.-]*:/i.test(path)) return undefined;

  try {
    const base = new URL(api.defaults.baseURL, window.location.origin);
    base.pathname = `${base.pathname.replace(/\/api\/?$/, '').replace(/\/$/, '')}/`;
    return new URL(path, base).href;
  } catch {
    return undefined;
  }
};
